import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
  ApiIndexiasvalueGetRequestParams,
  IndexEntityService,
  OrganizationService,
  ReferenceService
} from '../../../apiModule1';
import {NgClass, NgStyle} from '@angular/common';
import {map} from 'rxjs/operators';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {OnInputChange} from '../../OnInputChange';
import {organizationResolver} from '../../organization/organization.resolver';

export const years: { id: number, name: string }[] = [
  {id: 1, name: '2024'},
  {id: 2, name: '2025'},
  {id: 3, name: '2026'}
] as const;

export const quarters: { id: number, name: string }[] = [
  {id: 1, name: '1'},
  {id: 2, name: '2'},
  {id: 3, name: '3'},
  {id: 4, name: '4'}
] as const

@Component({
  selector: 'pas-filter-dialog-index-ias',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    MatButton,
    NgClass,
    NgStyle,
    MultiSelect2Component,
  ],
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss','../../index-entity/filter-dialog/filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDialogComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<FilterDialogComponent>);
  referenceService = inject(ReferenceService);
  data: Record<string, any> = inject(MAT_DIALOG_DATA)
  organizationService = inject(OrganizationService);
  indexEntityService = inject(IndexEntityService);


  archiveStatuses: Status[] = []
  indexes: IndexIas[] = []
  organizations: Organization[] = []
  periods: CriterionPeriod[] = []
  years: { id: number, name: string }[] = years
  quarters: { id: number, name: string }[] = quarters

  private _converDataToObjectArray(data: { id: number, name: string }[], v: string[]): { id: number, name: string }[]|undefined {
    if (!v) return
    const res = data.filter(d => v.some(e => e == d.name))
    return res;
  }

  form = new FormGroup({
    archive: new FormControl(this.data && this.data['statusIds'] || []),
    index: new FormControl(this.data && this.data['indexIasValueIds'] || []),
    organization: new FormControl(this.data && this.data['organizationIds'] || []),
    period: new FormControl(this.data && this.data['periodIds'] || []),
    year: new FormControl(this.data && this._converDataToObjectArray(this.years, this.data['years']) || []),
    quarter: new FormControl(this.data && this._converDataToObjectArray(this.quarters, this.data['quarters']) || []),
  })

  private _valueToFilterList = 'indexiasvalue' as const;

  dataIndex: OnInputChange<IndexIas> = new OnInputChange(this.indexEntityService, 'apiIndexFilterlistGet', this._valueToFilterList)
  dataOrganization: OnInputChange<Organization> = new OnInputChange(this.organizationService, 'apiOrganizationFilterlistGet', this._valueToFilterList)

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    console.log('filter-dialog data', this.data);

    this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values)).subscribe((v: Status[]) => {
      this.archiveStatuses = v;
    })

    this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values)).subscribe((v: CriterionPeriod[]) => {
      this.periods = v;
    })

    this.dataIndex.on().subscribe(v => {
      this.indexes = v;
      this.cdr.markForCheck();
    })

    this.dataOrganization.on().subscribe(v => {
      this.organizations = v;
      this.cdr.markForCheck();
    })

  }


  onReset(): void {
    this.form.reset();
  }

  onApply() {
    const res: ApiIndexiasvalueGetRequestParams = {
      statusIds: this.form.get('archive')!.value,
      indexIasValueIds: this.form.get('index')!.value,
      organizationIds: this.form.get('organization')!.value,
      periodIds: this.form.get('period')!.value,
      years: this.form.get('year')!.value?.map((v: { id: number; name: string }) => +v.name) ||[],
      quarters: this.form.get('quarter')!.value?.map((v: { id: number; name: string }) => +v.name)||[],
    }

    this.dialogRef.close(res);
  }

  protected readonly organizationResolver = organizationResolver;
}


